<div class="side-menu" id="side_menu" [ngClass]="{ collapsed: isCollapsed }" (click)="$event.stopPropagation()">
   <div class="menu-toggle">
      <button class="toggle-btn" type="button" (click)="toggleSidebar($event)">
         <div class="hamburger-icon" [ngClass]="{ collapsed: isCollapsed }">
            <span class="line line1"></span>
            <span class="line line2"></span>
            <span class="line line3"></span>
         </div>
      </button>
   </div>
   <ul class="menu-list">
      <li *ngIf="showHome" class="menu-item" (click)="allLink.home(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Home')" (mouseleave)="onTooltipMouseLeave()" routerLink="/home" routerLinkActive="active">
         <img src="../../../assets/images/homeicon.svg" alt="">
         <span class="menu-text">Home</span>
      </li>
      <li *ngIf="showProfile" class="menu-item" (click)="hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Profile')" (mouseleave)="onTooltipMouseLeave()" routerLink="/profile" routerLinkActive="active">
         <img src="../../../assets/images/profile.svg" alt="">
         <span class="menu-text">Profile</span>
      </li>


      <li *ngIf="showHrmanager" class="menu-group" [ngClass]="{ open: isMenuOpen('hr') || (isCollapsed && isSubmenuHovered('hr')) }">
         <div class="menu-item has-submenu" 
              (click)="!isCollapsed && toggleMenu('hr', $event)" 
              (mouseenter)="onSubmenuHover('hr', $event); onTooltipMouseEnter($event, 'HR Manager')" 
              (mouseleave)="onSubmenuHoverLeave('hr'); onTooltipMouseLeave()">
            <div class="menu-title">
               <div class="menu-left">
                  <img src="../../../assets/images/hrmanagericon.svg" alt="">
                  <span class="menu-text">HR Manager</span>
               </div>
               <i class="arrow" [class.open]="isMenuOpen('hr') && !isCollapsed">
                  <img class="arrow-image" src="../../../assets/images/arrow_drop_up.svg" alt="">
               </i>
            </div>
         </div>

         <!-- Inline submenu for expanded mode -->
         <ul class="submenu inline-submenu" *ngIf="!isCollapsed && isMenuOpen('hr')">
            <li>
               <a routerLink="/hr-manager/employelist" routerLinkActive="active" (click)="closeMenus()">Employees</a>
            </li>
            <li>
               <a routerLink="/hr-manager/companylist" routerLinkActive="active" (click)="closeMenus()">Companies</a>
            </li>
            <li>
               <a routerLink="/hr-manager/businesslist" routerLinkActive="active" (click)="closeMenus()">Business Units</a>
            </li>
            <li>
               <a routerLink="/hr-manager/departmentlist" routerLinkActive="active" (click)="closeMenus()">Departments</a>
            </li>
            <li>
               <a routerLink="/hr-manager/holidaylist" routerLinkActive="active" (click)="closeMenus()">Holidays</a>
            </li>
         </ul>

         <!-- Floating submenu for collapsed mode on hover -->
         <div class="floating-submenu" 
              *ngIf="isCollapsed && isSubmenuHovered('hr')" 
              (click)="$event.stopPropagation()"
              (mouseenter)="onFloatingSubmenuEnter()"
              (mouseleave)="onFloatingSubmenuLeave('hr')">
            <ul>
               <li>
                  <a routerLink="/hr-manager/employelist" routerLinkActive="active" (click)="closeMenus(); $event.stopPropagation()">Employee List</a>
               </li>
               <li>
                  <a routerLink="/hr-manager/companylist" routerLinkActive="active" (click)="closeMenus(); $event.stopPropagation()">Company List</a>
               </li>
               <li>
                  <a routerLink="/hr-manager/businesslist" routerLinkActive="active" (click)="closeMenus(); $event.stopPropagation()">Business List</a>
               </li>
               <li>
                  <a routerLink="/hr-manager/departmentlist" routerLinkActive="active" (click)="closeMenus(); $event.stopPropagation()">Department List</a>
               </li>
               <li>
                  <a routerLink="/hr-manager/holidaylist" routerLinkActive="active" (click)="closeMenus(); $event.stopPropagation()">List of Holiday</a>
               </li>
            </ul>
         </div>
      </li>
        <li *ngIf="showExpense" class="menu-item" (click)="allLink.openExpenseManager(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Expense Manager')" (mouseleave)="onTooltipMouseLeave()" routerLink="/expense-manager/all-claim" routerLinkActive="active">
         <img src="../../../assets/images/expensemanager.svg" alt="">
         <span class="menu-text">Expense Manager</span>
      </li>


      <li *ngIf="showDocument" class="menu-item" (click)="allLink.employeeDocuments(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Documents')" (mouseleave)="onTooltipMouseLeave()" routerLink="/employee-documents" routerLinkActive="active">
         <img src="../../../assets/images/documenticon.svg" alt="">
         <span class="menu-text">Documents</span>
      </li>
      <li *ngIf="showCircular" class="menu-item" (click)="allLink.amplusCircular(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Circulars')" (mouseleave)="onTooltipMouseLeave()" routerLink="/circular" routerLinkActive="active">
         <img src="../../../assets/images/formsicon.svg" alt="">
         <span class="menu-text">Circulars</span>
      </li>

      <li class="menu-item" (click)="allLink.amplusGuidelinesPolicy(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Guidelines & Policy')" (mouseleave)="onTooltipMouseLeave()" routerLink="/guidelines-policy" routerLinkActive="active">
         <img src="../../../assets/images/employeehandbook.svg" alt="">
         <span class="menu-text">Guidelines & Policy</span>
      </li>
      <li *ngIf="showMemories" class="menu-item" (click)="allLink.amplusMemories(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Memories')" (mouseleave)="onTooltipMouseLeave()" routerLink="/memories" routerLinkActive="active">
         <img src="../../../assets/images/memoriesicon.svg" alt="">
         <span class="menu-text">Memories</span>
      </li>
      <li *ngIf="canViewOffRollMenu()" class="menu-item" (click)="allLink.offRollLeaveLop(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Off-Roll Attendance')" (mouseleave)="onTooltipMouseLeave()" routerLink="/lop-management" routerLinkActive="active">
         <img src="../../../assets/images/OffRollIcon.svg" alt="">
         <span class="menu-text">Off-Roll Attendance</span>
      </li>
      <li *ngIf="showProduct" class="menu-item" (click)="allLink.amplusProduct(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Products')" (mouseleave)="onTooltipMouseLeave()" routerLink="/products" routerLinkActive="active">
         <img src="../../../assets/images/productsicon.svg" alt="">
         <span class="menu-text">Products</span>
      </li>
      <li *ngIf="showPoa" class="menu-item" (click)="allLink.amplusPoa(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'POA')" (mouseleave)="onTooltipMouseLeave()" routerLink="/poa" routerLinkActive="active">
         <img src="../../../assets/images/poaicon.svg" alt="">
         <span class="menu-text">POA</span>
      </li>
      <li *ngIf="showOnboarding" class="menu-item" (click)="allLink.employeeOnboarding; hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Onboarding')" (mouseleave)="onTooltipMouseLeave()" routerLink="/hr-home" routerLinkActive="active">
         <img src="../../../assets/images/onboarding.svg" alt="">
         <span class="menu-text">Onboarding</span>
      </li>

      <li *ngIf="showAmdoc" class="menu-group" [ngClass]="{ open: isMenuOpen('amdoc') || (isCollapsed && isSubmenuHovered('amdoc')) }">
         <div class="menu-item has-submenu" 
              (click)="!isCollapsed && toggleMenu('amdoc', $event)" 
              (mouseenter)="onSubmenuHover('amdoc', $event); onTooltipMouseEnter($event, 'AmDoc')" 
              (mouseleave)="onSubmenuHoverLeave('amdoc'); onTooltipMouseLeave()">
            <div class="menu-title">
               <div class="menu-left">
                  <img src="../../../assets/images/amdoc.svg" alt="">
                  <span class="menu-text">AmDoc</span>
               </div>
               <i class="arrow" [class.open]="isMenuOpen('amdoc') && !isCollapsed">
                  <img class="arrow-image" src="../../../assets/images/arrow_drop_up.svg" alt="">
               </i>
            </div>
         </div>
         <!-- Inline submenu for expanded mode -->
         <ul class="submenu inline-submenu" *ngIf="!isCollapsed && isMenuOpen('amdoc')">
            <li *ngFor="let template of templateNames">
               <a routerLink="/template" [class.active]="template.id === activeTemplateId" (click)="logTemplateName(template); closeMenus()">{{ template.name }}</a>
            </li>
         </ul>
         <!-- Floating submenu for collapsed mode on hover -->
         <div class="floating-submenu" 
              *ngIf="isCollapsed && isSubmenuHovered('amdoc')" 
              (click)="$event.stopPropagation()"
              (mouseenter)="onFloatingSubmenuEnter()"
              (mouseleave)="onFloatingSubmenuLeave('amdoc')">
            <ul>
               <li *ngFor="let template of templateNames">
                  <a routerLink="/template" [class.active]="template.id === activeTemplateId" (click)="logTemplateName(template); closeMenus(); $event.stopPropagation()">{{ template.name }}</a>
               </li>
            </ul>
         </div>
      </li>

    

      <!-- code hide because  e-separation not going on Prod. start from  here -->

      <li *ngIf="showEsep" class="menu-item" (mouseenter)="onTooltipMouseEnter($event, 'E-Seperation')" (mouseleave)="onTooltipMouseLeave()" routerLink="/e-separation" routerLinkActive="active">
         <img src="../../../assets/images/Exit.svg" alt="">
         <span class="menu-text">E-Seperation</span>
      </li>
      <li *ngIf="showNDCBtn" class="menu-item" (mouseenter)="onTooltipMouseEnter($event, 'NDC')" (mouseleave)="onTooltipMouseLeave()" routerLink="/ndc" routerLinkActive="active">
         <img src="../../../assets/images/hrmanagericon.svg" alt="">
         <span class="menu-text">NDC</span>
      </li>
   
      <!-- code hide because  e-separation not going on Prod. End  here -->
   
      <li class="menu-item" (click)="allLink.logout(); hideTooltip()" (mouseenter)="onTooltipMouseEnter($event, 'Logout')" (mouseleave)="onTooltipMouseLeave()">
         <img src="../../../assets/images/logouticons.svg" alt="">
         <span class="menu-text">Logout</span>
      </li>
   </ul>
</div>
<div id="mySidenav" class="sidenav" style="display: none;">
   <p class="closebtn" (click)="allLink.closeNav()">&times;</p>
   <!-- <div class="mainNameSection">
      <span *ngIf="showText" class="round" id="round"> {{initials}}</span>
      <span *ngIf="!showText" class="round" id="roundImg"> </span> -->
   <!-- <span class="name">{{dates.name}} <br> <span class="job_title">{{dates.job_title}}</span></span> -->
   <!-- <span class="name">{{fullName}} <br> <span class="job_title">{{jobTitle}}</span></span>
      </div> -->
   <!-- <a href="javascript:void(0)" (click)="allLink.openLnd()"> <i class="fa fa-user" aria-hidden="true"></i> L&D
      Manager</a>
      <a href="javascript:void(0)" (click)="allLink.openAppraisal()"><i class="fa fa-th-large" aria-hidden="true"></i>
      Appraisal Portal</a>
      <a href="javascript:void(0)"> <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Documents</a>
      <a href="javascript:void(0)" (click)="allLink.logout()"> <i class="fa fa-power-off" aria-hidden="true"></i>
      Logout</a> -->
   <!-- side-overlay-menu.component.html -->
   <div class="side-menu">
      <ul>
         <!-- <li class="mainMenu" (click)="allLink.toggleSubMenu('menu1')" [class.active]="allLink.isSubMenuOpen('menu1')">
            <p><img src="../../../assets/images/01.svg"> Dashboard</p>
            </li>
            <ul class="subMenu" [hidden]="!allLink.isSubMenuOpen('menu1')">
             <li (click)="allLink.home()">Home</li>
             <li (click)="allLink.openLnd()">L&D Manager</li>
             <li (click)="allLink.openAppraisal()">Appraisal Portal</li>
             <li>GreytHR</li>
            </ul> -->
         <!-- <li class="mainMenu" (click)="allLink.toggleSubMenu('menu2')" [class.active]="allLink.isSubMenuOpen('menu2')">
            <p><img src="../../../assets/images/02.svg"> Documents</p>
            </li> -->
         <!-- <li class="mainMenu" (click)="allLink.home()">
            <p><img src="../../../assets/images/01.svg"> Dashboard</p>
            </li>
            <li class="mainMenu" (click)="allLink.openLnd()">
            <p><img src="../../../assets/images/L&D.svg"> L&D Manager</p>
            </li>
            <li class="mainMenu" (click)="allLink.openAppraisal()">
            <p><img src="../../../assets/images/Appraisal.svg"> Appraisal Portal</p>
            </li>
            <li class="mainMenu" (click)="allLink.opengreytHR()">
            <p><img src="../../../assets/images/GreytHR.svg"> GreytHR</p>
            </li>
            
            <li class="mainMenu" (click)="allLink.employeeDocuments()">
            <p><img src="../../../assets/images/02.svg"> Documents</p>
            </li>
            
            <span *ngIf="showClaim">
            <li class="mainMenu" (click)="allLink.openExpenseManager()">
            <p><img src="../../../assets/images/GreytHR.svg"> Expense Manager</p>
            </li>
            </span>
            <li class="mainMenu" (click)="allLink.openHrManager()">
            <p><img src="../../../assets/images/02.svg"> HR Manager</p>
            </li> -->
         <!-- <ul  class="subMenu" [hidden]="!allLink.isSubMenuOpen('menu2')">
            <li>Submenu 3</li>
            <li>Submenu 4</li>
            </ul> -->
         <!-- <li class="mainMenu" (click)="allLink.logout()">
            <p><img src="../../../assets/images/Logout.svg"> Logout</p>
            </li> -->
         <!-- Add more menu items and submenus as needed -->
      </ul>
   </div>
</div>
<div id="fullPageOverLay"></div>